// extracted by mini-css-extract-plugin
export default {"activitiesWrapper":"Home_activitiesWrapper__OBFsN","activitiesList":"Home_activitiesList__tKYyf"};